module.exports = function() {
  return new Worker(__webpack_public_path__ + "48e1e50aa88933abe2c6.worker.js");
};